/**
 * Pure helpers for linking an uploaded school document to frameworks
 * (de-slop ADM-9). The upload flow used to ask for numeric framework IDs in a
 * `window.prompt`; it now uses a checkbox sheet, and these helpers hold the
 * selection and form-field logic so it can be unit-tested without React Native.
 */

export interface LinkableFramework {
  id: number;
  framework_key: string;
  name?: Record<string, string> | null;
}

/** Name in the UI language, then English, then Turkish, then the key (one helper app-wide, I18N-R09). */
export { frameworkDisplayName } from '../../utils/frameworkName';

/** Adds the id when it is not selected, removes it when it is. Keeps order. */
export function toggleFrameworkId(selected: number[], id: number): number[] {
  return selected.includes(id) ? selected.filter((value) => value !== id) : [...selected, id];
}

export interface DocumentUploadFields {
  coaching_method: 'framework_linked' | 'school_document';
  /** JSON array string, present only when at least one framework is linked. */
  linked_framework_ids?: string;
}

/**
 * Multipart fields for the document upload. Only ids of frameworks that are
 * still available are sent, each once.
 */
export function documentUploadFields(
  selectedIds: number[],
  available: Pick<LinkableFramework, 'id'>[],
): DocumentUploadFields {
  const allowed = new Set(available.map((framework) => framework.id));
  const ids = Array.from(new Set(selectedIds)).filter((id) => allowed.has(id));
  if (ids.length === 0) return { coaching_method: 'school_document' };
  return { coaching_method: 'framework_linked', linked_framework_ids: JSON.stringify(ids) };
}
